import React from 'react'
import SectionContainer from '../../../../../Homepage/SectionContainer'
import BreadCrumb from '../../../../../component/BreadCrumb/BreadCrumb'
import bell from '../../../../svg/bell.svg'
import { Col, Row } from 'reactstrap'
import brandmark1 from "../../../../../assets/kangaroo/brandMark1.jpg"
import brandmark2 from "../../../../../assets/kangaroo/brandMark2.jpg"
import brandmark3 from "../../../../../assets/kangaroo/brandMark3.jpg"
import brandmark4 from "../../../../../assets/kangaroo/brandMark4.jpg"
import brandmark5 from "../../../../../assets/kangaroo/brandMark5.jpg"
import brandmark6 from "../../../../../assets/kangaroo/brandMark6.jpg"
import brandmark7 from "../../../../../assets/kangaroo/brandMark7.jpg"
import brandmark8 from "../../../../../assets/kangaroo/brandMark8.jpg"
import brandmark9 from "../../../../../assets/kangaroo/brandMark9.jpg"
import brandmark10 from "../../../../../assets/kangaroo/brandMark10.jpg"
import brandmark11 from "../../../../../assets/kangaroo/brandMark11.jpg"
import brandmark12 from "../../../../../assets/kangaroo/brandMark12.jpg"
import brandmark13 from "../../../../../assets/kangaroo/brandMark13.jpg"
import brandmark14 from "../../../../../assets/kangaroo/brandMark14.jpg"
import brandmark15 from "../../../../../assets/kangaroo/brandMark15.jpg"
import brandmark16 from "../../../../../assets/kangaroo/brandMark16.jpg"
import brandmark17 from "../../../../../assets/kangaroo/brandMark17.jpg"
import brandmark18 from "../../../../../assets/kangaroo/brandMark18.jpg"
import brandmark19 from "../../../../../assets/kangaroo/brandMark19.jpg"
import identitymessage1 from "../../../../../assets/kangaroo/identityMessage1.jpg"
import guidecommunication1 from "../../../../../assets/kangaroo/guideCommunication1.jpg"
import guidecommunication2 from "../../../../../assets/kangaroo/guideCommunication2.jpg"
import guidecommunication3 from "../../../../../assets/kangaroo/guideCommunication3.jpg"
import guidecommunication4 from "../../../../../assets/kangaroo/guideCommunication4.jpg"
import guidecommunication5 from "../../../../../assets/kangaroo/guideCommunication5.jpg"
import guidecommunication6 from "../../../../../assets/kangaroo/guideCommunication6.jpg"
import guideartwork1 from "../../../../../assets/kangaroo/guideArtwork1.jpg"
import guideartwork2 from "../../../../../assets/kangaroo/guideArtwork2.jpg"
import guideartwork3 from "../../../../../assets/kangaroo/guideArtwork3.jpg"
import guideartwork4 from "../../../../../assets/kangaroo/guideArtwork4.jpg"
import guideartwork5 from "../../../../../assets/kangaroo/guideArtwork5.jpg"
import guideartwork6 from "../../../../../assets/kangaroo/guideArtwork6.jpg"
import guideartwork7 from "../../../../../assets/kangaroo/guideArtwork7.jpg"
import guidematerial1 from "../../../../svg/guideMaterial1.svg"
import guidematerial2 from "../../../../svg/guideMaterial2.svg"
import guidematerial3 from "../../../../svg/guideMaterial3.svg"
import guidematerial4 from "../../../../svg/guideMaterial4.svg"
import guidematerial5 from "../../../../svg/guideMaterial5.svg"
import guidematerial6 from "../../../../svg/guideMaterial6.svg"
import guidematerial7 from "../../../../svg/guideMaterial7.svg"
import guidematerial8 from "../../../../svg/guideMaterial8.svg"
import guidematerial9 from "../../../../svg/guideMaterial9.svg"
import guidematerial10 from "../../../../svg/guideMaterial10.svg"
import guidematerial11 from "../../../../svg/guideMaterial11.svg"
import guidematerial12 from "../../../../svg/guideMaterial12.svg"
import guidematerial13 from "../../../../svg/guideMaterial13.svg"
import guidematerial14 from "../../../../svg/guideMaterial14.svg"
import guidematerial15 from "../../../../svg/guideMaterial15.svg"
import guidematerial16 from "../../../../svg/guideMaterial16.svg"
import bottomimg from "../../../../svg/bottom1.svg"


const Guideline = () => {
    const text = `All artworks within KEFEVS's Brand Identity Guidelines-including those for Brand Communication, Sales Communication, Corporate Communication, and Corporate Materials-are meticulously designed using a consistent grid system. This grid is based on 1x1 cm boxes, which span the entire size of each artwork, ensuring precision and alignment in every design.

Key design elements, such as the KEFEVS Primary or Secondary logos, images, text, and other visual components, are aligned either horizontally or vertically with these grid lines. Regardless of the artwork's size or layout, the grid box dimensions remain constant at 1x1 cm, providing a uniform foundation for all designs.

The artworks presented in below are developed entirely on this grid system, emphasizing structure, balance, and consistency across all visual communications. This standardized approach ensures a cohesive brand identity across various formats and mediums.`

    const text2 = `The above-displayed Brand Visual Mark Artwork includes complete sets of horizontal and vertical designs. However, moving forward, the "Brand Visual Mark Artwork with Messaging" and "Product, Services & Partnership Showcase Artworks" (for all three types), along with all other Sales Communication and Corporate Communication Artworks, are shown below in a 1:1 ratio only. The complete sets of horizontal and vertical sizes for these artworks are available in their respective formats within the "Artwork & Assets" section of this site. Additionally, horizontal and vertical sizes for Corporate Materials Artwork, where required, are also included in the "Artwork & Assets" section.`

    const bmText = `The 1:1 Brand Visual Mark Artwork serves as the foundation for creating consistent and cohesive designs across square, horizontal, and vertical layouts. It ensures uniformity in the placement and proportions of design elements within the Brand Visual Mark.
✋ In the 1:1 Artwork, as well as in subsequent Brand Visual Mark Artworks detailed in below, the defined sizes and placement areas for the KEFEVS Secondary Logo, the gradient overlay (using two colors from the primary or secondary color palette), and the key image cannot be altered. While the dimensions and placement areas may adjust proportionally based on square, horizontal, or vertical layouts, the overall structure and hierarchy of components remain unchanged.
The only customizable elements within these artworks are:
<span class="fw-bold">Images:</span>
Editable within the designated image area.
<span class="fw-bold">Gradients:</span>
Modifiable within the gradient overlay area.`

    const IdentityData = [
        {
            id: 1,
            titles: ["1:1 Brand Visual Mark Artwork"],
            text: bmText,
            images: [brandmark1]
        },
        {
            id: 2,
            titles: ["1.25:1 Brand Visual Mark Artwork"],
            images: [brandmark2]
        },
        {
            id: 3,
            titles: ["1.5:1 Brand Visual Mark Artwork"],
            images: [brandmark3]
        },
        {
            id: 4,
            titles: ["1.75:1 Brand Visual Mark Artwork"],
            images: [brandmark4]
        },
        {
            id: 5,
            titles: ["2:1 Brand Visual Mark Artwork"],
            images: [brandmark5]
        },
        {
            id: 6,
            titles: ["2.25:1 Brand Visual Mark Artwork"],
            images: [brandmark6]
        },
        {
            id: 7,
            titles: ["2.5:1 Brand Visual Mark Artwork"],
            images: [brandmark7]
        },
        {
            id: 8,
            titles: ["2.75:1 Brand Visual Mark Artwork"],
            images: [brandmark8]
        },
        {
            id: 9,
            titles: ["3:1 Brand Visual Mark Artwork"],
            images: [brandmark9]
        },
        {
            id: 10,
            titles: [
                "1:1.25 Brand Visual Mark Artwork",
                "1:1.5 Brand Visual Mark Artwork",
                "1:1.75 Brand Visual Mark Artwork"
            ],
            images: [brandmark10, brandmark11, brandmark12]
        },
        {
            id: 11,
            titles: [
                "1:2 Brand Visual Mark Artwork",
                "1:2.25 Brand Visual Mark Artwork",
                "1:2.5 Brand Visual Mark Artwork"
            ],
            images: [brandmark13, brandmark14, brandmark15]
        },
        {
            id: 12,
            titles: [
                "1:2.75 Brand Visual Mark Artwork",
                "1:3 Brand Visual Mark Artwork",
            ],
            images: [brandmark16, brandmark17]
        },
        {
            id: 13,
            titles: [
                "16:9 Brand Visual Mark Artwork",
            ],
            images: [brandmark18]
        },
        {
            id: 14,
            titles: [
                "9:16 Brand Visual Mark Artwork",
            ],
            images: [brandmark19]
        }






    ];

    const imText = `The 1:1 Brand Visual Mark with Messaging Artwork serves as the foundation for creating consistent and cohesive designs across square, horizontal, and vertical layouts. It ensures uniformity in the placement and proportions of design elements within the Brand Visual Mark with Messaging.
✋ In the 1:1 Artwork, as well as in all other Brand Visual Mark with Messaging Artworks, the defined sizes and placement areas for the KEFEVS Secondary Logo, the gradient overlay (using two colors from the primary or secondary color palette), and the key image cannot be altered. While the dimensions and placement areas may adjust proportionally based on square, horizontal, or vertical layouts, the overall structure and hierarchy of components remain unchanged.
The only customizable elements within these artworks are:
<span class="fw-bold">Images:</span>
Editable within the designated image area.
<span class="fw-bold">Text:</span>
Adjustable within the designated text area.
<span class="fw-bold">Gradients:</span>
Modifiable within the gradient overlay area.`

    const IdentityMessageData = [
        {
            id: 1,
            titles: ["1:1 Brand Visual Mark with Messaging Artwork"],
            text: imText,
            images: [identitymessage1]
        },


    ];

    const guidelineText = `The 1:1 Product, Services & Partnership Showcase Artwork-1 serves as the foundation for creating consistent and cohesive designs to promote KEFEVS’s products, services, and partnerships. This artwork is the first of three types specifically developed for showcasing these elements across square, horizontal, and vertical layouts.
✋ The 1:1 Artwork, as well as in all other Product, Services & Partnership Showcase Artworks, the defined sizes and placement areas for the KEFEVS Secondary Logo, the gradient overlay (using two colors from the primary or secondary color palette), and the key image cannot be altered. While the dimensions and placement areas may adjust proportionally based on square, horizontal, or vertical layouts, the overall structure and hierarchy of components remain unchanged.
The only customizable elements within these artworks are:
<span class="fw-bold">Images:</span>
Editable within the designated image area.
<span class="fw-bold">Text:</span>
Adjustable within the designated text area.
<span class="fw-bold">Gradients:</span>
Modifiable within the gradient overlay area.
`

    const GuideLinesSalesData = [
        {
            id: 1,
            titles: ["1:1 Product, Services & Partnership Showcase Artwork-1 "],
            text: guidelineText,
            images: [guidecommunication1]
        },
        {
            id: 2,
            titles: ["1:1 Product, Services & Partnership Showcase Artwork-2"],
            images: [guidecommunication2]
        },
        {
            id: 3,
            titles: ["1:1 Product, Services & Partnership Showcase Artwork-3"],
            images: [guidecommunication3]
        },
        {
            id: 4,
            titles: ["1:1 Program, Event & Fair-1"],
            images: [guidecommunication4]
        },
        {
            id: 5,
            titles: ["1:1 Program, Event & Fair-2"],
            images: [guidecommunication5]
        },
        {
            id: 6,
            titles: ["1:1 Visa Achievement Announcement"],
            images: [guidecommunication6]
        },


    ];

    const GuideArtWorkData = [
        {
            id: 1,
            titles: ["1:1 Seasonal Celebration Artwork-1"],
            images: [guideartwork1]
        },
        {
            id: 2,
            titles: ["1:1 Seasonal Celebration Artwork-2"],
            images: [guideartwork2]
        },
        {
            id: 3,
            titles: ["1:1 Birthday Celebration Artwork"],
            images: [guideartwork3]
        },
        {
            id: 4,
            titles: ["1:1 Congratulations & Felicitation Artwork-1"],
            images: [guideartwork4]
        },
        {
            id: 5,
            titles: ["1:1 Congratulations & Felicitation Artwork-2"],
            images: [guideartwork5]
        },
        {
            id: 6,
            titles: ["1:1 Notice & Announcement Artwork-1"],
            images: [guideartwork6]
        },
        {
            id: 7,
            titles: ["1:1 Notice & Announcement Artwork-2"],
            images: [guideartwork7]
        },



    ];

    const GuideMaterialsData = [
        {
            id: 1,
            titles: ["Business Card"],
            images: [guidematerial1],
            size: 6
        },
        {
            id: 2,
            titles: ["Identity Card "],
            images: [guidematerial2],
            size: 6
        },
        {
            id: 3,
            titles: ["Letterhead"],
            images: [guidematerial3],
            size: 6
        },
        {
            id: 4,
            titles: ["Envelope-1"],
            images: [guidematerial4],
            size: 12
        },
        {
            id: 5,
            titles: ["Envelope-2"],
            images: [guidematerial5],
            size: 8
        },
        {
            id: 6,
            titles: ["Certificate-1"],
            images: [guidematerial6],
            size: 12
        },
        {
            id: 7,
            titles: ["Certificate-2"],
            images: [guidematerial7],
            size: 12
        },
        {
            id: 8,
            titles: ["Presentation Starting Frame"],
            images: [guidematerial8],
            size: 12
        },
        {
            id: 9,
            titles: ["Presentation Inside Frame"],
            images: [guidematerial9],
            size: 12
        },
        {
            id: 10,
            titles: ["Publication Cover-1"],
            images: [guidematerial10],
            size: 6
        },
        {
            id: 11,
            titles: ["Publication Cover-2"],
            images: [guidematerial11],
            size: 6
        },
        {
            id: 12,
            titles: ["Notepad"],
            images: [guidematerial12],
            size: 12
        },
        {
            id: 13,
            titles: ["Signage-1"],
            images: [guidematerial13],
            size: 8
        },
        {
            id: 14,
            titles: ["Signage-2"],
            images: [guidematerial14],
            size: 8
        },
        {
            id: 15,
            titles: ["In-House Activities"],
            images: [guidematerial15],
            size: 6
        },
        {
            id: 16,
            titles: ["Photo Frame"],
            images: [guidematerial16],
            size: 7
        },

    ];



    return (
        <SectionContainer>
            <BreadCrumb items={[
                { title: "HOME", link: "/" },
                { title: "BRAND IDENTITY GUIDELINE", link: "/brand-identity-guideline" },
                { title: "GUIDELINE" },
            ]} instituition={false} className="" />
            <h1 className="font-level-1" style={{ marginBottom: "6rem" }}>GUIDELINES.</h1>
            <Row>
                <Col lg={1} md={1} sm={2}>
                    <img src={bell} alt="" className='img-fluid' />
                </Col>
                <Col lg={11} md={11} sm={10}>
                    <p
                        className="country-paragraph-text"
                        style={{ whiteSpace: "pre-line", }}
                        dangerouslySetInnerHTML={{ __html: text }}
                    ></p>
                </Col>
            </Row>
            <hr className="line" />
            <h1 className="font-level-2" ><span className="text-muted">GUIDELINES.</span>BRAND COMMUNICATION ARTWORKS</h1>
            <hr className="line" style={{ marginBottom: "5rem" }} />
            {IdentityData.map((data) => {
                const imageCount = Array.isArray(data.images) ? data.images.length : 0;

                // Decide column size
                let colSize = 12;
                if (imageCount === 1) colSize = 6;
                else if (imageCount === 2) colSize = 4;
                else if (imageCount === 3) colSize = 4;

                return (
                    <React.Fragment key={data.id}>

                        {/* KEEP original main title */}
                        <h1 className="country-paragraph-text">{data.title}</h1>

                        <Row>

                            {/* CASE: Text + Single Image */}
                            {data.text && imageCount === 1 && (
                                <>
                                    <Col lg={6} md={12}>

                                        {/* ✅ Title per image */}
                                        {data.titles?.[0] && (
                                            <h1
                                                className="country-paragraph-text"
                                                style={{ marginBottom: "1rem" }}
                                            >
                                                {data.titles[0]}
                                            </h1>
                                        )}

                                        <img
                                            src={data.images[0]}
                                            alt=""
                                            style={{ width: "100%" }}
                                        />
                                    </Col>
                                    <Col></Col>
                                    <Col lg={5} md={12}>
                                        <p
                                            className="country-paragraph-text ms-5 "
                                            style={{
                                                whiteSpace: "pre-line",
                                                marginTop: "2.5rem"
                                            }}
                                            dangerouslySetInnerHTML={{ __html: data.text.replace(/\n/g, '<span class="text-gap"></span>') }}
                                        />
                                    </Col>
                                </>
                            )}

                            {/* CASE: Only Images */}
                            {!data.text && Array.isArray(data.images) &&
                                data.images.map((img, index) => (
                                    <Col key={index} lg={colSize} md={12}>

                                        {/* ✅ Title per image */}
                                        {data.titles?.[index] && (
                                            <h1
                                                className="country-paragraph-text"
                                                style={{ marginBottom: "1rem" }}
                                            >
                                                {data.titles[index]}
                                            </h1>
                                        )}

                                        <img
                                            src={img}
                                            alt=""
                                            style={{ width: "100%" }}
                                        />
                                    </Col>
                                ))}

                            {/* CASE: Text + Multiple Images */}
                            {data.text && imageCount > 1 && (
                                <>
                                    {Array.isArray(data.images) &&
                                        data.images.map((img, index) => (
                                            <Col key={index} lg={colSize} md={12}>

                                                {/* ✅ Title per image */}
                                                {data.titles?.[index] && (
                                                    <h1
                                                        className="country-paragraph-text"
                                                        style={{ marginBottom: "1rem" }}
                                                    >
                                                        {data.titles[index]}
                                                    </h1>
                                                )}

                                                <img
                                                    src={img}
                                                    alt=""
                                                    style={{ width: "100%" }}
                                                />
                                            </Col>
                                        ))}

                                    <Col lg={12}>
                                        <p
                                            className="country-paragraph-text"
                                            style={{
                                                whiteSpace: "pre-line",
                                                marginTop: "3rem"
                                            }}
                                            dangerouslySetInnerHTML={{ __html: data.text }}
                                        />
                                    </Col>
                                </>
                            )}

                        </Row>

                        <hr
                            className="line"
                            style={{ marginTop: "5rem", marginBottom: "5rem" }}
                        />
                    </React.Fragment>
                );
            })}
            <Row>
                <Col lg={1} md={1} sm={2}>
                    <img src={bell} alt="" className='img-fluid' />
                </Col>
                <Col lg={11} md={11} sm={10}>
                    <p
                        className="country-paragraph-text"
                        style={{ whiteSpace: "pre-line", }}
                        dangerouslySetInnerHTML={{ __html: text2 }}
                    ></p>
                </Col>
            </Row>
            <hr className="line" style={{ marginTop: "3rem", marginBottom: "5rem" }} />
            {IdentityMessageData.map((data) => {
                const imageCount = Array.isArray(data.images) ? data.images.length : 0;

                // Decide column size
                let colSize = 12;
                if (imageCount === 1) colSize = 6;
                else if (imageCount === 2) colSize = 6;
                else if (imageCount === 3) colSize = 4;

                return (
                    <React.Fragment key={data.id}>

                        {/* KEEP original main title */}
                        <h1 className="country-paragraph-text">{data.title}</h1>

                        <Row>

                            {/* CASE: Text + Single Image */}
                            {data.text && imageCount === 1 && (
                                <>
                                    <Col lg={6} md={12}>

                                        {/* ✅ Title per image */}
                                        {data.titles?.[0] && (
                                            <h1
                                                className="country-paragraph-text"
                                                style={{ marginBottom: "1rem" }}
                                            >
                                                {data.titles[0]}
                                            </h1>
                                        )}

                                        <img
                                            src={data.images[0]}
                                            alt=""
                                            style={{ width: "100%" }}
                                        />
                                    </Col>
                                    <Col></Col>

                                    <Col lg={5} md={12}>
                                        <p
                                            className="country-paragraph-text ms-5 "
                                            style={{
                                                whiteSpace: "pre-line",
                                                marginTop: "2.5rem"
                                            }}
                                            dangerouslySetInnerHTML={{ __html: data.text.replace(/\n/g, '<span class="text-gap"></span>') }}
                                        />
                                    </Col>
                                </>
                            )}

                            {/* CASE: Only Images */}
                            {!data.text && Array.isArray(data.images) &&
                                data.images.map((img, index) => (
                                    <Col key={index} lg={colSize} md={12}>

                                        {/* ✅ Title per image */}
                                        {data.titles?.[index] && (
                                            <h1
                                                className="country-paragraph-text"
                                                style={{ marginBottom: "1rem" }}
                                            >
                                                {data.titles[index]}
                                            </h1>
                                        )}

                                        <img
                                            src={img}
                                            alt=""
                                            style={{ width: "100%" }}
                                        />
                                    </Col>
                                ))}

                            {/* CASE: Text + Multiple Images */}
                            {data.text && imageCount > 1 && (
                                <>
                                    {Array.isArray(data.images) &&
                                        data.images.map((img, index) => (
                                            <Col key={index} lg={colSize} md={12}>

                                                {/* ✅ Title per image */}
                                                {data.titles?.[index] && (
                                                    <h1
                                                        className="country-paragraph-text"
                                                        style={{ marginBottom: "1rem" }}
                                                    >
                                                        {data.titles[index]}
                                                    </h1>
                                                )}

                                                <img
                                                    src={img}
                                                    alt=""
                                                    style={{ width: "100%" }}
                                                />
                                            </Col>
                                        ))}

                                    <Col lg={12}>
                                        <p
                                            className="country-paragraph-text"
                                            style={{
                                                whiteSpace: "pre-line",
                                                marginTop: "3rem"
                                            }}
                                            dangerouslySetInnerHTML={{ __html: data.text }}
                                        />
                                    </Col>
                                </>
                            )}

                        </Row>


                    </React.Fragment>
                );
            })}
            <hr className="line" style={{ marginTop: "7.5rem" }} />
            <h1 className="font-level-2" ><span className="text-muted">GUIDELINES.</span>SALES COMMUNICATION ARTWORKS</h1>
            <hr className="line" style={{ marginBottom: "5rem" }} />
            {GuideLinesSalesData.map((data, index) => {
                const imageCount = Array.isArray(data.images) ? data.images.length : 0;

                // Decide column size
                let colSize = 12;
                if (imageCount === 1) colSize = 6;
                else if (imageCount === 2) colSize = 6;
                else if (imageCount === 3) colSize = 4;

                return (
                    <React.Fragment key={data.id}>

                        {/* KEEP original main title */}
                        <h1 className="country-paragraph-text">{data.title}</h1>

                        <Row>

                            {/* CASE: Text + Single Image */}
                            {data.text && imageCount === 1 && (
                                <>
                                    <Col lg={6} md={12}>

                                        {/* ✅ Title per image */}
                                        {data.titles?.[0] && (
                                            <h1
                                                className="country-paragraph-text"
                                                style={{ marginBottom: "1rem" }}
                                            >
                                                {data.titles[0]}
                                            </h1>
                                        )}

                                        <img
                                            src={data.images[0]}
                                            alt=""
                                            style={{ width: "100%" }}
                                        />
                                    </Col>
                                    <Col></Col>

                                    <Col lg={5} md={12}>
                                        <p
                                            className="country-paragraph-text ms-5 "
                                            style={{
                                                whiteSpace: "pre-line",
                                                marginTop: "2.5rem"
                                            }}
                                            dangerouslySetInnerHTML={{ __html: data.text.replace(/\n/g, '<span class="text-gap"></span>') }}
                                        />
                                    </Col>
                                </>
                            )}

                            {/* CASE: Only Images */}
                            {!data.text && Array.isArray(data.images) &&
                                data.images.map((img, index) => (
                                    <Col key={index} lg={colSize} md={12}>

                                        {/* ✅ Title per image */}
                                        {data.titles?.[index] && (
                                            <h1
                                                className="country-paragraph-text"
                                                style={{ marginBottom: "1rem" }}
                                            >
                                                {data.titles[index]}
                                            </h1>
                                        )}

                                        <img
                                            src={img}
                                            alt=""
                                            style={{ width: "100%" }}
                                        />
                                    </Col>
                                ))}

                            {/* CASE: Text + Multiple Images */}
                            {data.text && imageCount > 1 && (
                                <>
                                    {Array.isArray(data.images) &&
                                        data.images.map((img, index) => (
                                            <Col key={index} lg={colSize} md={12}>

                                                {/* ✅ Title per image */}
                                                {data.titles?.[index] && (
                                                    <h1
                                                        className="country-paragraph-text"
                                                        style={{ marginBottom: "1rem" }}
                                                    >
                                                        {data.titles[index]}
                                                    </h1>
                                                )}

                                                <img
                                                    src={img}
                                                    alt=""
                                                    style={{ width: "100%" }}
                                                />
                                            </Col>
                                        ))}

                                    <Col lg={12}>
                                        <p
                                            className="country-paragraph-text"
                                            style={{
                                                whiteSpace: "pre-line",
                                                marginTop: "3rem"
                                            }}
                                            dangerouslySetInnerHTML={{ __html: data.text }}
                                        />
                                    </Col>
                                </>
                            )}

                        </Row>


                        <hr
                            className="line"
                            style={{ marginTop: "5rem", marginBottom: "5rem", opacity: index === GuideLinesSalesData.length - 1 ? 0 : 0.3 }}
                        />

                    </React.Fragment>
                );
            })}
            <hr className="line" />
            <h1 className="font-level-2" ><span className="text-muted">GUIDELINES.</span>CORPORATE COMMUNICATION ARTWORKS</h1>
            <hr className="line" style={{ marginBottom: "5rem" }} />
            {GuideArtWorkData.map((data, index) => {
                const imageCount = Array.isArray(data.images) ? data.images.length : 0;

                // Decide column size
                let colSize = 12;
                if (imageCount === 1) colSize = 6;
                else if (imageCount === 2) colSize = 6;
                else if (imageCount === 3) colSize = 4;

                return (
                    <React.Fragment key={data.id}>

                        {/* KEEP original main title */}
                        <h1 className="country-paragraph-text">{data.title}</h1>

                        <Row>

                            {/* CASE: Text + Single Image */}
                            {data.text && imageCount === 1 && (
                                <>
                                    <Col lg={6} md={12}>

                                        {/* ✅ Title per image */}
                                        {data.titles?.[0] && (
                                            <h1
                                                className="country-paragraph-text"
                                                style={{ marginBottom: "1rem" }}
                                            >
                                                {data.titles[0]}
                                            </h1>
                                        )}

                                        <img
                                            src={data.images[0]}
                                            alt=""
                                            style={{ width: "100%" }}
                                        />
                                    </Col>

                                    <Col lg={6} md={12}>
                                        <p
                                            className="country-paragraph-text ms-5 "
                                            style={{
                                                whiteSpace: "pre-line",
                                                marginTop: "2.5rem"
                                            }}
                                            dangerouslySetInnerHTML={{ __html: data.text }}
                                        />
                                    </Col>
                                </>
                            )}

                            {/* CASE: Only Images */}
                            {!data.text && Array.isArray(data.images) &&
                                data.images.map((img, index) => (
                                    <Col key={index} lg={colSize} md={12}>

                                        {/* ✅ Title per image */}
                                        {data.titles?.[index] && (
                                            <h1
                                                className="country-paragraph-text"
                                                style={{ marginBottom: "1rem" }}
                                            >
                                                {data.titles[index]}
                                            </h1>
                                        )}

                                        <img
                                            src={img}
                                            alt=""
                                            style={{ width: "100%" }}
                                        />
                                    </Col>
                                ))}

                            {/* CASE: Text + Multiple Images */}
                            {data.text && imageCount > 1 && (
                                <>
                                    {Array.isArray(data.images) &&
                                        data.images.map((img, index) => (
                                            <Col key={index} lg={colSize} md={12}>

                                                {/* ✅ Title per image */}
                                                {data.titles?.[index] && (
                                                    <h1
                                                        className="country-paragraph-text"
                                                        style={{ marginBottom: "1rem" }}
                                                    >
                                                        {data.titles[index]}
                                                    </h1>
                                                )}

                                                <img
                                                    src={img}
                                                    alt=""
                                                    style={{ width: "100%" }}
                                                />
                                            </Col>
                                        ))}

                                    <Col lg={12}>
                                        <p
                                            className="country-paragraph-text"
                                            style={{
                                                whiteSpace: "pre-line",
                                                marginTop: "3rem"
                                            }}
                                            dangerouslySetInnerHTML={{ __html: data.text }}
                                        />
                                    </Col>
                                </>
                            )}

                        </Row>


                        <hr
                            className="line"
                            style={{ marginTop: "5rem", marginBottom: "5rem", opacity: index === GuideArtWorkData.length - 1 ? 0 : 0.3 }}
                        />

                    </React.Fragment>
                );
            })}
            <hr className="line" />
            <h1 className="font-level-2" ><span className="text-muted">GUIDELINES.</span>CORPORATE MATERIALS ARTWORKS</h1>
            <hr className="line" style={{ marginBottom: "5rem" }} />

            {GuideMaterialsData.map((data, index) => {
                const colSize = data.size;
                return (
                    <React.Fragment key={data.id}>
                        <Row
                            className="mb-5"
                            style={{ alignItems: "center" }}
                        >
                            {Array.isArray(data.images) &&
                                data.images.map((img, index) => (
                                    <Col key={index} lg={colSize} md={12}>

                                        {/* ✅ Title per image */}
                                        {data.titles?.[index] && (
                                            <h1
                                                className="country-paragraph-text"
                                                style={{ marginBottom: "1rem" }}
                                            >
                                                {data.titles[index]}
                                            </h1>
                                        )}

                                        <img
                                            src={img}
                                            alt=""
                                            style={{ width: "100%" }}
                                        />
                                    </Col>
                                ))}

                            <Col lg={12}>
                                <p
                                    className="country-paragraph-text"
                                    style={{
                                        whiteSpace: "pre-line",
                                        marginTop: "3rem"
                                    }}
                                    dangerouslySetInnerHTML={{ __html: data.text }}
                                />
                            </Col>
                        </Row>


                        <hr
                            className="line"
                            style={{ marginTop: "5rem", marginBottom: "5rem" }}
                        />

                    </React.Fragment>
                );
            })}
            <div className="text-center">
                <img src={bottomimg} alt="" className='w-25 ' style={{ marginBottom: "5rem" }} />
            </div>



        </SectionContainer>
    )
}

export default Guideline